module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIzIiB2aWV3Qm94PSIwIDAgMTUgMyI+CiAgPGxpbmUgaWQ9IkxpbmVfMTI2IiBkYXRhLW5hbWU9IkxpbmUgMTI2IiB5MT0iMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjUgMS41KSByb3RhdGUoOTApIiBmaWxsPSJub25lIiBzdHJva2U9IiNhOWE5YTkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIiBvcGFjaXR5PSIwLjkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/leaderboard-progress.svg
// module id = WqES
// module chunks = 0